<template>
  <div>
    <v-stepper
      class="elevation-0 stepper_header"
      altLabels
      v-model="$store.state.editing_step"
    >
      <v-stepper-header size="20" class="elevation-0 ">
        <template v-for="n in $store.state.westeps">
          <v-stepper-step
            v-if="
              !n.requiredFeature ||
                n.requiredFeature.includes($store.state.wizard.meta.feature)
            "
            :key="getKey('step', n.index)"
            :editable="true"
            :step="n.index"
          >
            {{ n.name }}
          </v-stepper-step>

          <v-divider
            v-if="
              (!n.requiredFeature ||
                n.requiredFeature.includes($store.state.wizard.meta.feature) ) &&
                n.index !== $store.state.westeps.length
            "
            :key="getKey('sep', n.index)"
          ></v-divider>
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <template v-for="n in $store.state.westeps">
          <v-stepper-content :key="getKey('step', n.index)" :step="n.index">
            <component
              :is="lazyComponents[n.index - 1]"
              v-if="$store.state.editing_step == n.index"
            ></component>
          </v-stepper-content>
        </template>
      </v-stepper-items>
    </v-stepper>
    <div style="height:30px" />
  </div>
</template>

<script>
import config from "../config";

export default {
  data() {
    return {
      config: config,
    };
  },

  computed: {
    lazyComponents() {
      let components = [];
      for (let n in this.$store.state.westeps) {
        components.push(this.$store.state.westeps[n].component);
      }
      return components;
    },
  },

  methods: {
    getKey(tag, index) {
      return tag + "-" + index.toString();
    },
  },
};
</script>

<style>
.stepper_header {
}
</style>
